import { RootState } from '../../../applicationStore';
import { ActivityState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getActivityState = (state: RootState): ActivityState =>
  state.activity;

export const getActivityLoader = createSelector(
  getActivityState,
  (state): boolean => state.loading,
);

export const getActivityData = createSelector(
  getActivityState,
  (state): ActivityState['data'] | null => state?.data || null,
);
